export default 'https://tme.understood.org/assets/milk.db074dde.glb'